<nav
  class="navbar navbar-expand-lg align-items-lg-center ps-2"
  [ngClass]="currentBg()"
  style="background-color: white !important"
>
  <div class="float-start">
    <img
      src="../../../assets/images/FetrapiLogo2.png"
      alt=""
      class="app-brand-logo ui-w-50"
    />
  </div>

  <!-- Navbar toggle -->
  <button
    class="navbar-toggler"
    type="button"
    (click)="isExpanded = !isExpanded"
  >
    <span class="navbar-toggler-icon"></span>
  </button>

  <div class="navbar-collapse collapse" [ngbCollapse]="!isExpanded">
    <div class="navbar-nav align-items-lg-center"></div>
  </div>

  <div
    id="notificationCounter"
    class="notificationCounter"
    [ngClass]="{'hidden': !hasNotifications()}"
    (click)="showNotifications()"
  >
    <a href="javascript:void(0)">
      <span class="ion ion-ios-notifications"></span>
      <span class="badge" id="notificationsBadge">{{getNotificationsCounter()}}</span>
    </a>
  </div>

  <div class="navbar-nav align-items-lg-center ms-auto" id="navUser">
    <div class="navbar-nav py-2">
      <li class="nav-item dropdown" ngbDropdown placement="bottom-right">
        <a
          class="nav-link dropdown-toggle menuArrow"
          aria-haspopup="true"
          aria-expanded="false"
          ngbDropdownToggle
        >
          <i class="ion ion-md-contact me-lg-1"></i>
          <span class="d-none d-lg-inline">{{ loggedUser.displayName }}</span>
        </a>

        <div class="dropdown-menu" ngbDropdownMenu>
          <span class="dropdown-item text-muted">
            <i class="ion ion-ios-mail me-1"></i>
            EMail<br /><span class="text-primary-1">{{
              !!loggedUser.mail ? loggedUser.mail : "Unknown"
            }}</span>
          </span>
          <span class="dropdown-item text-muted">
            <i class="ion ion-md-mic me-1"></i>
            Language<br /><span class="text-primary-1">{{
              loggedUser.preferredLanguage
            }}</span>
          </span>
          <span class="dropdown-item text-muted">
            <i class="ion ion-md-information-circle me-1"></i>
            MemberID<br /><span class="text-primary-1">{{
              loggedUser.groupGId
            }}</span>
          </span>
          <div class="dropdown-divider"></div>
          <a
            href="javascript:void(0)"
            (click)="onLogout()"
            class="dropdown-item text-muted"
          >
            <i class="ion ion-md-exit fa-fw me-1"></i>
            <span class="text-primary-1">Logout</span>
          </a>
        </div>
      </li>
    </div>
    <div _ngcontent-bgc-c3="" class="d-none d-md-block">
      <span _ngcontent-bgc-c3="">[ {{ loggedUser.groupName }} ]</span>
    </div>
  </div>
</nav>
